import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import RelationshipView from './RelationshipView';

// The read-only copy of the client Relationships tab. It lists the relationships by priority and has
// no add, edit or delete.
const RelationshipList = (props) => {
  const clientData = props.clientData;
  const relationships = clientData.relationships;

  const relationshipView = React.useMemo(() => {
    return Object.values(relationships || {}).sort((a, b) => a.priority - b.priority);
  }, [relationships]);

  return (
    <Stack>
      {
        relationshipView.map((e) => (
          <RelationshipView
            key={e.relationshipRn}
            relationshipData={e}
          />
        ))
      }
    </Stack>
  );
};

RelationshipList.propTypes = {
  clientData: PropTypes.object.isRequired,
};
export default React.memo(RelationshipList);
